import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import './styles.scss';
import logo from '../../assets/images/logo/logo.png';
import avt from '../../assets/images/user.jpg';
import Cookies1 from 'js-cookie';
import ReloadableLink from '../../pages/Reload';
import menus from '../../pages/menu';
import { useAuth } from '../../hooks/useAuth';

const Header = () => {
    const [scroll, setScroll] = useState(false);
    const [menuActive, setMenuActive] = useState(false);
    const [activeDropdown, setActiveDropdown] = useState(null);
    const [mobileSubMenu, setMobileSubMenu] = useState(null);
    const { isAuthenticated, user } = useAuth();
    const dropdownTimeoutRef = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
            setScroll(window.scrollY > 300);
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
            // Clean up timeout on unmount
            if (dropdownTimeoutRef.current) {
                clearTimeout(dropdownTimeoutRef.current);
            }
        };
    }, []);



    const handleMenuActive = () => {
        setMenuActive(!menuActive);
        if (menuActive) {
            setMobileSubMenu(null);
        }
    };

    const handleDesktopDropdown = (index, event) => {
        event.preventDefault();
        event.stopPropagation();
        setActiveDropdown(activeDropdown === index ? null : index);
    };

    const handleMouseEnter = (index) => {
        // Clear any existing timeout
        if (dropdownTimeoutRef.current) {
            clearTimeout(dropdownTimeoutRef.current);
            dropdownTimeoutRef.current = null;
        }
        setActiveDropdown(index);
    };

    const handleMouseLeave = () => {
        // Small delay to allow moving to dropdown
        dropdownTimeoutRef.current = setTimeout(() => {
            setActiveDropdown(null);
        }, 150);
    };

    const handleDropdownMouseEnter = () => {
        // Clear timeout when mouse enters dropdown content
        // This keeps dropdown open when hovering over dropdown items
        if (dropdownTimeoutRef.current) {
            clearTimeout(dropdownTimeoutRef.current);
            dropdownTimeoutRef.current = null;
        }
    };

    const handleDropdownMouseLeave = () => {
        // Close dropdown when mouse leaves dropdown content
        setActiveDropdown(null);
    };

    const handleMobileDropdown = (index, event) => {
        event.preventDefault();
        setMobileSubMenu(mobileSubMenu === index ? null : index);
    };

    // Close dropdowns when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            // Don't close if clicking on dropdown trigger or dropdown content
            if (!event.target.closest('.nav-item')) {
                setActiveDropdown(null);
            }
        };
        
        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, []);

    const loginButton = () => (
        <div className="auth-button">
            <ReloadableLink to="/login" className="login-btn">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10 17L15 12L10 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M15 12H3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span>Login</span>
            </ReloadableLink>
        </div>
    );

    const userMenu = () => {
        return(
            <div className="user-menu-container">
                <Dropdown className='user-dropdown'>
                    <Dropdown.Toggle className="user-avatar-btn">
                        <div className="avatar-wrapper">
                            <img src={avt} alt="User Avatar" />
                            <div className="status-indicator"></div>
                        </div>
                                </Dropdown.Toggle>

                    <Dropdown.Menu className="user-dropdown-menu">
                        <div className="user-dropdown-header">
                            <div className="user-avatar-large">
                                <img src={avt} alt="User Avatar" />
                            </div>
                            <div className="user-details">
                                <h6>{user?.name}</h6>
                                <span className="user-role">Verified User</span>
                            </div>
                        </div>
                        
                        <div className="dropdown-divider"></div>
                        
                        <Dropdown.Item as={Link} to="/user-profile" className="user-dropdown-item">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                <path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                <circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                            <span>Profile</span>
                                </Dropdown.Item>
                        
                        <Dropdown.Item as={Link} to="/wallet" className="user-dropdown-item">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                <path d="M21 12V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V17C3 18.1046 3.89543 19 5 19H19C20.1046 19 21 18.1046 21 17V16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M3 10H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M7 15H7.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                            <span>My Wallet</span>
                                </Dropdown.Item>
                        
                        <Dropdown.Item as={Link} to="/referral" className="user-dropdown-item">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                <path d="M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                <circle cx="8.5" cy="7" r="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M20 8V14L23 11L20 8Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M20 11H15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                            <span>Referral Program</span>
                                </Dropdown.Item>
                                
                        <div className="dropdown-divider"></div>
                        
                        <Dropdown.Item as={Link} to="/logout" className="user-dropdown-item logout">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                <path d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M16 17L21 12L16 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M21 12H9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                            <span>Logout</span>
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        );
    }

    return (
        <header id="header_main" className={`modern-header ${scroll ? 'is-fixed' : ''}`}>
            <div className="container-fluid">
                <div className="navbar-container">
                    <div className="navbar-content">
                        {/* Logo Section */}
                        <div className="navbar-brand">
                            <Link to="/" className="logo-link">
                                <div className="logo-wrapper">
                                    <img src={logo} alt="CetoEX" className="logo-main" />
                                </div>
                            </Link>
                        </div>

                                                                        {/* Desktop Navigation */}
                        <nav className="desktop-nav">
                            <div className="nav-menu">
                                            {menus.map((data, idx) => (
                                    <div 
                                        key={idx} 
                                        className={`nav-item ${data.namesub ? 'has-dropdown' : ''} ${activeDropdown === idx ? 'active' : ''}`}
                                    >
                                        {data.namesub ? (
                                            <div 
                                                className="dropdown-wrapper"
                                                onMouseEnter={() => handleMouseEnter(idx)}
                                                onMouseLeave={handleMouseLeave}
                                            >
                                                <button 
                                                    type="button"
                                                    className="nav-link dropdown-trigger"
                                                    onClick={(e) => handleDesktopDropdown(idx, e)}
                                                >
                                                    <span>{data.name}</span>
                                                    <svg className={`dropdown-icon ${activeDropdown === idx ? 'rotated' : ''}`} width="12" height="8" viewBox="0 0 12 8" fill="none">
                                                        <path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                                    </svg>
                                                </button>
                                                {activeDropdown === idx && (
                                                    <div 
                                                        className="dropdown-menu show"
                                                        onMouseEnter={handleDropdownMouseEnter}
                                                        onMouseLeave={handleDropdownMouseLeave}
                                                    >
                                                        <div className="dropdown-content">
                                                            {data.namesub.map((submenu) => (
                                                                <Link 
                                                                    key={submenu.id} 
                                                                    to={submenu.links} 
                                                                    className="dropdown-item"
                                                                    onClick={() => setActiveDropdown(null)}
                                                                >
                                                                    {submenu.sub}
                                                                </Link>
                                                            ))}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        ) : (
                                            <Link 
                                                to={data.links} 
                                                className="nav-link"
                                            >
                                                {data.name}
                                            </Link>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </nav>

                        {/* Right Section */}
                        <div className="navbar-actions">
                            {/* Secondary Menu */}
                            <div className="secondary-menu">
                                <Dropdown className="nav-dropdown">
                                    <Dropdown.Toggle className="dropdown-trigger">
                                        About
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className="modern-dropdown">
                                        <Dropdown.Item as={Link} to="/faq" className="dropdown-link">
                                            <span>FAQ</span>
                                        </Dropdown.Item>
                                        <Dropdown.Item as={Link} to="/about-cetoex" className="dropdown-link">
                                            <span>About CetoEX</span>
                                        </Dropdown.Item>
                                        <Dropdown.Item as={Link} to="/privacy" className="dropdown-link">
                                            <span>Privacy Policy</span>
                                        </Dropdown.Item>
                                        <Dropdown.Item as={Link} to="/fee-schedule" className="dropdown-link">
                                            <span>Fee Schedule</span>
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>

                                <Dropdown className="nav-dropdown">
                                    <Dropdown.Toggle className="dropdown-trigger">
                                        News
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className="modern-dropdown">
                                        <Dropdown.Item href="https://news.cetoex.com/top-news/" className="dropdown-link">
                                            <span>Top News</span>
                                        </Dropdown.Item>
                                        <Dropdown.Item href="https://news.cetoex.com/category/cetoex-special/" className="dropdown-link">
                                            <span>CetoEX Special</span>
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                                </div>

                            

                            {/* User Section */}
                            <div className="user-section">
                                {isAuthenticated ? userMenu() : loginButton()}
                            </div>

                            {/* Mobile Menu Button */}
                            <button 
                                className={`mobile-menu-btn ${menuActive ? 'active' : ''}`} 
                                onClick={handleMenuActive}
                                aria-label="Toggle mobile menu"
                            >
                                <span className="hamburger-line"></span>
                                <span className="hamburger-line"></span>
                                <span className="hamburger-line"></span>
                            </button>
                        </div>
                    </div>

                    {/* Mobile Navigation */}
                    <div className={`mobile-nav ${menuActive ? 'active' : ''}`}>
                        <div className="mobile-nav-overlay" onClick={() => setMenuActive(false)}></div>
                        <div className="mobile-nav-content">
                            <div className="mobile-menu">
                                {menus.map((data, idx) => (
                                    <div key={idx} className={`mobile-nav-item ${mobileSubMenu === idx ? 'active' : ''}`}>
                                        <div className="mobile-nav-link">
                                            {data.namesub ? (
                                                <>
                                                    <span className="mobile-link">{data.name}</span>
                                                    <button 
                                                        className="mobile-dropdown-toggle"
                                                        onClick={(e) => handleMobileDropdown(idx, e)}
                                                    >
                                                        <svg className={`mobile-dropdown-icon ${mobileSubMenu === idx ? 'rotated' : ''}`} width="12" height="8" viewBox="0 0 12 8" fill="none">
                                                            <path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                                        </svg>
                                                    </button>
                                                </>
                                            ) : (
                                                <Link 
                                                    to={data.links} 
                                                    className="mobile-link"
                                                    onClick={() => setMenuActive(false)}
                                                >
                                                    {data.name}
                                                </Link>
                                            )}
                                        </div>
                                        {data.namesub && (
                                            <div className={`mobile-submenu ${mobileSubMenu === idx ? 'active' : ''}`}>
                                                {data.namesub.map((submenu) => (
                                                    <Link 
                                                        key={submenu.id} 
                                                        to={submenu.links} 
                                                        className="mobile-submenu-link"
                                                        onClick={() => {
                                                            setMenuActive(false);
                                                            setMobileSubMenu(null);
                                                        }}
                                                    >
                                                        {submenu.sub}
                                                    </Link>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>

                            {/* Mobile Secondary Menu */}
                            <div className="mobile-secondary-menu">
                                <div className="mobile-secondary-section">
                                    <h4>About</h4>
                                    <Link to="/faq" className="mobile-secondary-link">FAQ</Link>
                                    <Link to="/about-cetoex" className="mobile-secondary-link">About CetoEX</Link>
                                    <Link to="/privacy" className="mobile-secondary-link">Privacy Policy</Link>
                                    <Link to="/fee-schedule" className="mobile-secondary-link">Fee Schedule</Link>
                                </div>
                                <div className="mobile-secondary-section">
                                    <h4>News</h4>
                                    <a href="https://news.cetoex.com/top-news/" className="mobile-secondary-link">Top News</a>
                                    <a href="https://news.cetoex.com/category/cetoex-special/" className="mobile-secondary-link">CetoEX Special</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
}

export default Header;
